import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Pricing.css";
import Footer from "../components/Footer"; // Ensure correct path

const Pricing = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false); // ✅ modal state

  const handleDispatchClick = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dispatch-history"); // ✅ logged in
    } else {
      setShowAuthModal(true); // 🔥 show modal
    }
  };

  return (
    <div className="pricing-container">
      <div className="pricing-content">
        <h1 className="pricing-title">Transparent Pricing For You</h1>

        <div className="pricing-card">
          <div className="pricing-card-frame">
            <h2 className="plan-title">The Best</h2>
            <p className="plan-subtitle">What You'll Get</p>
          </div>

          {/* ✅ Features */}
          <div className="pricing-features-frame">
            <div className="pricing-feature">
              <img
                src="/mark-icon.svg"
                alt="Checkmark"
                className="feature-icon"
              />
              <p className="feature-text">
                Allow users to monitor their documents <br /> in transit.
              </p>
            </div>

            <div className="pricing-feature">
              <img
                src="/mark-icon.svg"
                alt="Checkmark"
                className="feature-icon"
              />
              <p className="feature-text">
                Provide confirmation once the document <br /> reaches its
                destination.
              </p>
            </div>

            <div className="pricing-feature">
              <img
                src="/mark-icon.svg"
                alt="Checkmark"
                className="feature-icon"
              />
              <p className="feature-text">
                Ensure confidentiality and safety of all <br /> documents.
              </p>
            </div>
          </div>

          {/* ✅ Button + Arrow */}
          <div className="pricing-arrow-frame">
            <img
              src="/arrow-icon.svg"
              alt="Arrow Icon"
              className="price-arrow-icon"
            />
            <button className="pricing-button" onClick={handleDispatchClick}>
              Dispatch Now
            </button>
          </div>
        </div>
      </div>

      <Footer />

      {/* ✅ Auth Modal */}
      {showAuthModal && (
        <div className="auth-modal-overlay">
          <div className="auth-modal">
            <h3>Login Required</h3>
            <p>
              You’ll need to sign in or create an account to dispatch your
              documents.
            </p>
            <div className="auth-modal-buttons">
              <button onClick={() => navigate("/login")}>Login</button>
              <button onClick={() => navigate("/signup")}>Sign Up</button>
              <button
                onClick={() => setShowAuthModal(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pricing;
